module.exports = ({
    "CDMS941OPT1": "รอใช้งาน",
    "CDMS941OPT2": "ใช้แล้ว",
    "CDMS941MSG003": "IP No. ที่เลือกถูกส่งเรียบร้อยแล้ว",
    "CDMS941MSG001": "ไม่สามารถส่ง IP No. ได้ เนื่องจากไม่มีข้อมูลหมายเลขยาดังกล่าว",
    "CDMS941MSG002": "ไม่สามารถส่ง IP No. ได้ เนื่องจากบางหมายเลขถูกใช้งานไปแล้ว",
    "CDMS941H001": "ต้นทาง",
    "CDMS941H002": "ปลายทาง",
    "CDMS941H003": "No.",
    "CDMS941H004": "ชื่อสถานวิจัย",
    "CDMS941H005": "IP No.",
    "CDMS941H006": "หมายเลขซีเรียล",
    "CDMS941H007": "สถานะ",
    "CDMS940H001": "ชื่อสถานวิจัย",
    "CDMS940H002": "วันที่ขนส่ง",
    "CDMS940H003": "IP No.",
    "CDMS940TT001": "สถานะการขนส่ง",
    "CDMS941TT001": "การขนส่งไปยังสถานวิจัย",
    "CDMS941BTN001": "โอนย้าย"
});
